import PaymentMethodDetail from './PaymentMethodDetail';

export default PaymentMethodDetail;



// WEBPACK FOOTER //
// ./src/scenes/PaymentMethods/PaymentMethodDetail/index.ts